<template>
  <div class="page-con">
    <div>
      <div class="page-con-header clearfix">
        <!--        <vxe-button-->
        <!--          icon="vxe-icon&#45;&#45;plus"-->
        <!--          type="primary"-->
        <!--          @click="importLog"-->
        <!--          v-if="isHavePermission('bankLog2:import')"-->
        <!--          >导入-->
        <!--        </vxe-button>-->
        <vxe-button
            icon="vxe-icon--download"
            type="primary"
            @click="exportData"
            v-if="isHavePermission('bankLog2.0:export')"
        >导出
        </vxe-button>
        <!--        <vxe-button-->
        <!--            icon="vxe-icon&#45;&#45;plus"-->
        <!--            type="primary"-->
        <!--            @click="clearData"-->
        <!--            v-if="isHavePermission('bankLog2:clear')"-->
        <!--        >-->
        <!--          批量清分-->
        <!--        </vxe-button>-->
        <!--        <vxe-button-->
        <!--          type="primary"-->
        <!--          @click="openImportLog"-->
        <!--          v-if="isHavePermission('bankLog2:importLog')"-->
        <!--          >导入日志-->
        <!--        </vxe-button>-->
        <vxe-button icon="vxe-icon--refresh" @click="getListData">刷新</vxe-button>
        <vxe-toolbar ref="xToolbar1" custom></vxe-toolbar>
      </div>
      <div class="finance-header" style="display: flex; flex-wrap: wrap; padding-bottom: 10px">
        <span class="finance-span finance-span-time">
          <label style="margin-right: 10px">时间</label>
          <DatePicker
              v-model="startTime"
              type="date"
              placeholder="选择日期"
              style="width: 120px"
          ></DatePicker>
          <i class="line-icon">--</i>
          <DatePicker
              v-model="endTime"
              type="date"
              placeholder="选择日期"
              style="width: 120px"
          ></DatePicker>
        </span>
        <span class="finance-span">
          <label>详情编号</label>
          <vxe-input
              v-model="searchFormData.detailNum"
              placeholder="输入详情编号"
              style="width: 120px"
          ></vxe-input>
        </span>
        <!--        <span class="finance-span">-->
        <!--          <label>订单编号</label>-->
        <!--          <vxe-input-->
        <!--            v-model="searchFormData.orderNum"-->
        <!--            placeholder="输入订单编号"-->
        <!--            style="width: 120px"-->
        <!--          ></vxe-input>-->
        <!--        </span>-->
        <span class="finance-span">
          <label>业务员</label>
          <Select
              v-model="searchSalesMan"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="
              (file) => remoteMethod(file, 'salesManOptions', 'twoReport', 'bankAccountsSalesMan')
            "
              :default-label="[]"
              :loading="searchLoading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="(file) => setDefaultOptions(file, 'salesManOptions')"
              placeholder="输入业务员"
          >
            <Option
                v-for="option in salesManOptions"
                :value="option.paramValue"
                :key="option.paramValue"
            >{{ option.paramValue }}</Option
            >
          </Select>
        </span>
        <span class="finance-span">
          <label>所属公司</label>
          <Select
              v-model="searchCompName"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="
              (file) =>
                remoteMethod(file, 'compNameOptions', 'twoReport', 'bankAccountsCompanyName')
            "
              :default-label="[]"
              :loading="searchLoading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="(file) => setDefaultOptions(file, 'compNameOptions')"
              placeholder="输入所属公司"
          >
            <Option
                v-for="option in compNameOptions"
                :value="option.paramValue"
                :key="option.paramValue"
            >{{ option.paramValue }}</Option
            >
          </Select>
        </span>
        <span class="finance-span">
          <label>公司账号</label>
          <Select
              v-model="searchCompAccount"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="
              (file) =>
                remoteMethod(file, 'compAccountOptions', 'twoReport', 'bankAccountsCompanyAccount')
            "
              :default-label="[]"
              :loading="searchLoading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="(file) => setDefaultOptions(file, 'compAccountOptions')"
              placeholder="输入公司账号"
          >
            <Option
                v-for="(option, index) in compAccountOptions"
                :value="option.paramId"
                :key="index"
            >{{ option.paramValue }}</Option
            >
          </Select>
        </span>
        <span class="finance-span">
          <label>客户名称</label>
          <Select
              v-model="searchClientName"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="
              (file) =>
                remoteMethod(file, 'clientNameOptions', 'twoReport', 'bankAccountsClientName')
            "
              :default-label="[]"
              :loading="searchLoading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="(file) => setDefaultOptions(file, 'clientNameOptions')"
              placeholder="输入客户名称"
          >
            <Option
                v-for="option in clientNameOptions"
                :value="option.paramValue"
                :key="option.paramValue"
            >{{ option.paramValue }}</Option
            >
          </Select>
        </span>
        <span class="finance-span">
          <label>创建人</label>
          <Select
              v-model="searchCreateUser"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="
              (file) =>
                remoteMethod(file, 'createUserOptions', 'twoReport', 'bankAccountsCreateUser')
            "
              :default-label="[]"
              :loading="searchLoading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="(file) => setDefaultOptions(file, 'createUserOptions')"
              placeholder="输入创建人"
          >
            <Option
                v-for="option in createUserOptions"
                :value="option.paramValue"
                :key="option.paramValue"
            >{{ option.paramValue }}</Option
            >
          </Select>
        </span>
        <span class="finance-span">
          <label>付款人</label>
          <Select
              v-model="searchPaymentsName"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="
              (file) =>
                remoteMethod(file, 'paymentsNameOptions', 'twoReport', 'bankAccountsPaymentsName')
            "
              :default-label="[]"
              :loading="searchLoading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="(file) => setDefaultOptions(file, 'paymentsNameOptions')"
              placeholder="输入付款人"
          >
            <Option
                v-for="option in paymentsNameOptions"
                :value="option.paramValue"
                :key="option.paramValue"
            >{{ option.paramValue }}</Option
            >
          </Select>
        </span>
        <span class="finance-span">
          <label>收款人</label>
          <Select
              v-model="searchRecName"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="
              (file) => remoteMethod(file, 'recNameOptions', 'twoReport', 'bankAccountsRecName')
            "
              :default-label="[]"
              :loading="searchLoading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="(file) => setDefaultOptions(file, 'recNameOptions')"
              placeholder="输入收款人"
          >
            <Option
                v-for="option in recNameOptions"
                :value="option.paramValue"
                :key="option.paramValue"
            >{{ option.paramValue }}</Option
            >
          </Select>
        </span>
        <span class="finance-span">
          <label>按创建时间</label>
          <vxe-select
              v-model="searchFormData.createTime"
              :options="timeOptions"
              placeholder="选择时间"
              style="width: 200px"
          ></vxe-select>
        </span>
        <span class="finance-span">
          <label>支付类型</label>
          <vxe-select
              v-model="searchFormData.isOnline"
              :options="isOnlineOptions"
              placeholder="选择类型"
              style="width: 120px"
          ></vxe-select>
        </span>
        <span class="finance-span">
          <label>清分</label>
          <vxe-select
              v-model="searchFormData.isAboutOrder"
              :options="isAboutOrderOptions"
              placeholder="选择是否清分"
              style="width: 120px"
          ></vxe-select>
        </span>
        <span class="finance-span">
          <label>流程类型</label>
          <vxe-select
              v-model="searchFormData.amountType"
              :options="amountTypeOptions"
              placeholder="选择类型"
              style="width: 120px"
          ></vxe-select>
        </span>
        <span class="finance-span">
          <label>来源</label>
          <vxe-select
              v-model="searchFormData.isFanwei"
              :options="isFanweiOptions"
              placeholder="选择来源"
              style="width: 120px"
          ></vxe-select>
        </span>
        <span class="finance-span">
          <label>流程编号</label>
          <vxe-input
              v-model="searchFormData.flowNum"
              placeholder="输入流程编号"
              style="width: 120px"
          ></vxe-input>
        </span>
        <span class="finance-span">
          <label>附件筛查</label>
          <vxe-select
              v-model="searchFormData.hasFile"
              :options="fileOptions"
              placeholder="全部"
              style="width: 70px"
          ></vxe-select>
        </span>
        <span class="finance-span" style="margin-left: auto">
          <Button
              type="primary"
              icon="ios-search"
              @click="getSearchListKey"
              style="border-radius: 5px"
          >搜索</Button
          >
          <Button @click="reset" style="margin-left: 10px; border-radius: 5px">重置</Button>
        </span>
      </div>
    </div>

    <div class="list-box common-shadow">
      <vxe-table
          ref="xTable"
          class="table-style"
          import-config
          export-config
          highlight-hover-row
          show-overflow
          show-footer
          max-height="650"
          border="none"
          align="center"
          :loading="loading"
          :footer-cell-class-name="footerCellClassName"
          :footer-method="footerMethod"
          :data="tableData"
          :row-class-name="getRowClass"
          resizable
      >
        <vxe-table-column type="seq" title="序号" align="center" width="60"></vxe-table-column>
        <vxe-table-column title=" " align="left" width="40">
          <template slot-scope="{ row, $rowIndex }">
            <Dropdown
                trigger="click"
                transfer
                v-if="$rowIndex !== 0"
            >
              <icon type="text" custom="iconfont icon-gengduo" size="14px"></icon>
              <DropdownMenu slot="list" style="left: 70px">
                <div style="display: flex; flex-direction: column">
                  <Button class="button-gengduo" v-if="isHavePermission('bankLog2.0:upload')" @click="goUpload(row)">
                    上传附件
                  </Button>
                  <Button class="button-gengduo" @click="editDetail(row)" v-if="row.isOnline === 1">编辑</Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="detailNum" title="详情编号" min-width="200">
          <template slot-scope="{ row }">
            <span @click="viewDetail(row)" style="color: #2d8cf0; cursor: pointer">{{
                row.detailNum
              }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="flowNum" title="流程编号" min-width="130">
          <template slot-scope="{ row }">
            <span
                @click="openProcedureDetail(row.flowId, 2)"
                style="color: #2d8cf0; cursor: pointer"
            >{{ row.flowNum }}</span
            >
          </template>
        </vxe-table-column>
        <!--        <vxe-table-column field="orderNum" title="订单编号" min-width="130">-->
        <!--          <template slot-scope="{ row }">-->
        <!--            <span @click="openOrder(row)" style="color: #2d8cf0; cursor: pointer">{{-->
        <!--              row.orderNum-->
        <!--            }}</span>-->
        <!--          </template>-->
        <!--        </vxe-table-column>-->
        <vxe-table-column field="salesMan" title="业务员" min-width="100"></vxe-table-column>
        <vxe-table-column field="addDate" title="日期" min-width="140">
          <template slot-scope="{ row }">
            <span>{{ row.addDate | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="note" title="摘要" min-width="140"></vxe-table-column>
        <!--        <vxe-table-column field="aboutAmount" title="关联金额" min-width="150"></vxe-table-column>-->
        <vxe-table-column field="debitAmountTotal" title="借方" min-width="150"></vxe-table-column>
        <vxe-table-column field="creditAmountTotal" title="贷方" min-width="150" style="padding: 0">
        </vxe-table-column>
        <vxe-table-column field="balance" title="余额" min-width="120">
          <template v-slot="{ row }">
            <div>{{ row.balance }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="companyName" title="所属公司" min-width="200"></vxe-table-column>
        <vxe-table-column field="payBank" title="开户行" min-width="200"></vxe-table-column>
        <vxe-table-column field="payAccount" title="银行帐号" min-width="200"></vxe-table-column>
        <vxe-table-column field="clientName" title="客户" min-width="120"></vxe-table-column>
        <vxe-table-column field="recName" title="收款人" min-width="120"></vxe-table-column>
        <vxe-table-column field="paymentsName" title="付款人" min-width="120"></vxe-table-column>

        <vxe-table-column field="createUser" title="创建人" width="100"></vxe-table-column>
        <vxe-table-column
            field="createTime"
            title="创建时间"
            width="120"
            v-if="isHavePermission('bankLog2:createTime')"
        >
          <template v-slot="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="search-filter">
      <vxe-modal
          class="timeModal"
          v-model="open"
          width="460"
          height="400"
          :show-footer="false"
          :showHeader="false"
      >
        <template v-slot>
          <DatePicker
              :open="open"
              confirm
              type="daterange"
              :split-panels="true"
              placeholder
              style="width: 432px"
              @on-change="handleChange"
              @on-clear="handleClear"
              @on-ok="handleOk"
          >
            <span class="date-slot"></span>
          </DatePicker>
        </template>
      </vxe-modal>
    </div>
    <vxe-modal v-model="isShowPaymentDetail" width="1300" height="680" resize position="center">
      <div slot="title">收付款详情</div>
      <payment-detail
          :cate="cate"
          :isShow="isShowPaymentDetail"
          ref="paymentDetail"
          @close="isShowPaymentDetail = false"
          @afterSave="afterSave"
      ></payment-detail>
    </vxe-modal>
    <vxe-modal
        v-model="templateVisible"
        :title="templateTitle"
        width="1000"
        height="620"
        @close="closeTemplate"
        position="center"
    >
      <import @goImport="goImport" @close="closeTemplate" ref="modalTemplate"></import>
    </vxe-modal>
    <!--END清分选择订单-->
    <vxe-modal v-model="showUploadTable" width="1000" height="350" title="上传附件" position="center">
      <upload-table ref="uploadTable" style="margin-top: 20px;" :row="payData"
                    :initFileList="payData.fileList"></upload-table>
      <div class="modal-footer add-btn-box">
        <Button type="primary" @click="commitUpdate">提交</Button>
      </div>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import $C from "@/consts/index";
import {SEARCH_TIME} from "@/filters/time";
import moment from "moment";
import getAuthOrization from "@/mixin/getAuthOrization";
import {
  bankLogFooter,
  getBlob,
  hideLoading,
  isEmpty,
  isNotEmpty,
  saveBlob,
  showLoading,
} from "@/utils/util";
import openProcedureDetail from "@/mixin/viewOrderDetail";
import CollectionDetail from "@/views/payment2.0/CollectionDetail.vue";
import PaymentDetail from "@/views/payment2.0/PaymentDetail.vue";
import InvoiceDetail from "@/components/order2.0/Invoice/Detail.vue";
import ClearData from "@/views/payment2.0/ClearData.vue";
import BankImportLog from "@/views/payment2.0/BankImportLog";
import Import from "@/components/common/Import"; // 导入
import ImportBankLog from "@/views/payment2.0/ImportBankLog";
import UploadTable from "@/components/modal/UploadTable";

const empties = [undefined, "", null, "null", {}, []];

export default {
  mixins: [getAuthOrization, openProcedureDetail],
  components: {
    PaymentDetail,
    Import,
    UploadTable
  },
  name: "FranchiseeList",
  data() {
    return {
      cate: "Collection",
      templateVisible: false,
      templateTitle: "",
      isShowCollectionDetail: false,
      isShowPaymentDetail: false,
      isShowInvoiceDetail: false,
      isShowClearData: false,
      importLogVisible: false,
      loading: false,
      searchLoading: false,
      importLogModal: false,
      queryAction: "",
      deleteAction: "",
      tableData: [],
      totalCounts: "",
      totalAmount: "",
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      searchParams: {
        addTimeBegin: "",
        addTimeEnd: "",
      },
      timeVal: "",
      rangeTime: "time",
      open: false,
      startTime: "",
      endTime: "",
      timeOptions: SEARCH_TIME.options,
      fileOptions: $C.HAS_FILE_TYPE.options,
      searchRecName: [],
      searchPaymentsName: [],
      searchCompAccount: [],
      searchClientName: [],
      searchCompName: [],
      searchCreateUser: [],
      searchSalesMan: [],
      recNameOptions: [],
      paymentsNameOptions: [],
      salesManOptions: [],
      compAccountOptions: [],
      clientNameOptions: [],
      compNameOptions: [],
      createUserOptions: [],
      searchFormData: {
        paymentsName: null,
        payAccount: null,
        recName: null,
        recAccount: null,
        addTime: null,
        salesMan: null,
        clientName: null,
        compName: null,
        createTime: null,
        isOnline: null,
        isFanwei: null,
        isAboutOrder: null,
        amountType: null,
        hasFile: null
      },
      searchFormItems: [
        {
          align: "right",
          span: 12,
          titleAlign: "left",
          itemRender: {
            name: "$buttons",
            children: [
              {props: {type: "submit", content: "搜索", status: "primary"}},
              {props: {type: "reset", content: "重置"}},
            ],
          },
        },
      ],
      isShowClearOrder: false, // 是否显示清分订单
      isOnlineOptions: [
        {
          label: "全部",
          value: null,
        },
        {
          label: "线上",
          value: 1,
        },
        {
          label: "线下",
          value: 0,
        },
      ],
      isFanweiOptions: [
        {
          label: "全部",
          value: null,
        },
        {
          label: "泛微",
          value: 1,
        },
        {
          label: "系统",
          value: 0,
        },
      ],
      isAboutOrderOptions: [
        {
          label: "全部",
          value: null,
        },
        {
          label: "是",
          value: 1,
        },
        {
          label: "否",
          value: 0,
        },
      ],
      amountTypeOptions: [
        {
          label: "全部",
          value: null,
        },
        {
          label: "收入",
          value: 1,
        },
        {
          label: "支出",
          value: 2,
        },
      ],
      showUploadTable: false,
      payData: {
        id: null,
        fileList: [],
        fileUuidList: []
      }
    };
  },
  watch: {
    // cate: {
    //   deep: true,
    //   immediate: true,
    //   handler: function (val, oldVal) {
    //     this.searchFormItems[1].title =
    //       val == "Collection" ? "收款信息编号" : "付款信息编号";
    //     switch (this.cate) {
    //       case "Collection":
    //         this.queryAction = "queryPaymentsBuyerList";
    //         this.deleteAction = "removePaymentsBuyer";
    //         break;
    //       case "Payment":
    //         this.queryAction = "queryPaymentsSellerList";
    //         this.deleteAction = "removePaymentsSeller";
    //         break;
    //       case "SellerPayment":
    //         this.queryAction = "queryPaymentsSellerLv2List";
    //         this.deleteAction = "removePaymentsSellerLv2";
    //         break;
    //     }
    //   },
    // },
    "searchFormData.createTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("createTime");
      },
    },
  },
  mounted() {
    this.$bus.$on("银行日记账2.0", () => {
      this.reset();
      this.startTime = moment().startOf("month").format("YYYY-MM-DD");
      this.endTime = moment().endOf("day").format("YYYY-MM-DD");
    });
    this.reset();
    this.startTime = moment().startOf("month").format("YYYY-MM-DD");
    this.endTime = moment().endOf("day").format("YYYY-MM-DD");
    this.getList('', 'compNameOptions', 'twoReport', 'bankAccountsCompanyName');
  },
  methods: {
    goUpload(row) {
      this.payData = {
        id: row.paymentId,
        fileList: [],
        fileUuidList: []
      }
      this.showUploadTable = true;
    },
    async commitUpdate() {
      showLoading();
      let res = await $api.payments.request('addPaymentsOrdersImgs', this.payData);
      hideLoading();

      if (res.status === 1) {
        this.$XModal.message("提交成功");
        this.showUploadTable = false;
        this.getSearchListKey();
      } else {
        if (!res.message) {
          res.message = "接口异常";
        }
        this.$XModal.message(res.message);
      }
    },
    afterSave() {
      this.isShowPaymentDetail = false;
      this.getListData();
    },
    importLog() {
      this.templateVisible = true;
      this.templateTitle = "导入银行日记账";
      this.$refs.modalTemplate.setExport("银行日记账导入模板.xls");
    },
    goImport() {
      this.templateVisible = false;
      this.importLogVisible = true;
    },
    closeTemplate() {
      this.templateVisible = false;
    },
    openImportLog() {
      this.importLogModal = true;
    },
    closeLogImport() {
      this.$refs.modalLogImport.close();
    },
    closeLogImportModal() {
      this.importLogVisible = false;
    },
    async exportData() {
      if (isEmpty(this.tableData)) {
        this.$XModal.message("先搜索数据");
        return;
      }
      showLoading();
      let res = getBlob("/api/order/twoReport/exportBankAccountPayments", this.searchParams);
      hideLoading();
      await saveBlob("导出银行日记账2.0.xls", res.data);
    },
    reset() {
      this.searchFormData = {
        paymentsName: null,
        payAccount: null,
        recName: null,
        recAccount: null,
        payBankCode: null,
        addTime: null,
        salesMan: null,
        clientName: null,
        compName: null,
        createTime: null,
        detailNum: null,
        orderNum: null,
        isFanwei: null,
        isAboutOrder: null,
        amountType: null,
      };
      this.startTime = "";
      this.endTime = "";
      this.searchRecName = [];
      this.searchPaymentsName = [];
      this.searchCompAccount = [];
      this.searchClientName = [];
      this.searchCompName = [];
      this.searchCreateUser = [];
      this.searchSalesMan = [];
      this.tableData = [];
    },
    openRangeDate(field) {
      if (this.searchFormData[field] === 1) {
        this.rangeTime = field;
        this.open = true;
      } else {
        this.open = false;
      }
    },
    handleChange(date) {
      this.timeVal = date;
      // this.timeVal = date.map( v => moment(v).valueOf());
      console.log(this.timeVal);
    },
    handleClear() {
    },
    clearData() {
      this.isShowClearData = true;
    },
    handleOk() {
      this.searchFormData[this.rangeTime] = this.timeVal;
      this.rangeTime = false;
      let that = this;
      setTimeout(() => {
        that.visible = true;
      }, 100);
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    async getList(query, options, url, path, columnType) {
      let params = {};

      if (!isEmpty(query)) {
        params.param = query;
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].get(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        let data = res.data;
        this[options] = [];
        data.map((i, index) => {
          if (index < 10) {
            this[options].push(i);
          }
        });
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    init() {
      // this.getListData()
    },
    setSearchParams(searchParams) {
      this.searchParams = searchParams;
    },
    getSearchListKey() {
      if (
          this.startTime === "" &&
          this.endTime === "" &&
          (this.searchFormData.createTime === "" || this.searchFormData.createTime === null) &&
          (this.searchFormData.detailNum === "" || this.searchFormData.detailNum === null) &&
          (this.searchFormData.orderNum === "" || this.searchFormData.orderNum === null) &&
          this.searchCompAccount.length === 0 &&
          this.searchClientName.length === 0 &&
          this.searchCompName.length === 0 &&
          this.searchCreateUser.length === 0 &&
          this.searchSalesMan.length === 0 &&
          this.searchRecName.length === 0 &&
          this.searchPaymentsName.length === 0
      ) {
        this.$XModal.alert({
          message: "请输入搜索条件",
          status: "error",
        });
        return;
      }
      let obj = this.searchFormData;
      let searchParams = {};
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== null && key !== "createTime") {
          searchParams[key] = obj[key];
        }
        if (obj["createTime"] && obj["createTime"].length > 0) {
          searchParams.createTimeBegin = moment(obj.createTime[0]).valueOf(); // 开始时间
          searchParams.createTimeEnd = moment(obj.createTime[1]).valueOf() + 86399000; // 结束时间
        }
      });
      searchParams.recName = this.searchRecName;
      searchParams.paymentsName = this.searchPaymentsName;
      searchParams.compAccount = this.searchCompAccount;
      searchParams.clientName = this.searchClientName;
      searchParams.compName = this.searchCompName;
      searchParams.createUser = this.searchCreateUser;
      searchParams.salesMan = this.searchSalesMan;
      this.searchParams = searchParams;
      this.getListData();
    },
    async getListData() {
      this.tableData = [];
      this.queryAction = "bankAccountsPayments";
      this.loading = true;
      this.searchParams.beginDate =
          this.startTime === "" ? this.startTime : this.$utils.timestamp(this.startTime);
      this.searchParams.endDate =
          this.endTime === "" ? this.endTime : this.$utils.timestamp(this.endTime) + 86399000;
      let params = empties.includes(this.searchParams) ? {} : this.searchParams;
      // params.orderBy = 2;
      let res = await $api.twoReport.request(this.queryAction, params);
      if (res.status === 1) {
        const curTableData = res.data.bankAccounts;
        let firstRow = {
          note: "期初余额",
          balance: res.data.initBalance,
        };
        curTableData.unshift(firstRow);
        let toggleColor = "row-bg-1";
        for (let i = 0; i < curTableData.length; i++) {
          let isCanClear = false;
          if (
              (curTableData[i].flowTypeCode == 7 && isEmpty(curTableData[i].aboutId)) ||
              (curTableData[i].flowTypeCode == 2 && curTableData[i].debitAmount != 0) ||
              (curTableData[i].flowTypeCode == 3 && curTableData[i].creditAmount != 0) ||
              curTableData[i].flowTypeCode == 8
          ) {
            isCanClear = true;
          }
          let obj = Object.assign(curTableData[i], {isCanClear});
          if (i === 0) {
            obj.balance = Math.round(res.data.initBalance * 100) / 100;
          } else {
            obj.balance =
                Math.round(
                    (Number(curTableData[i - 1].balance) +
                        Number(curTableData[i].debitAmount) -
                        Number(curTableData[i].creditAmount)) *
                    100
                ) / 100;
            //  obj.balance = (Number(curTableData[i - 1].balance) + Number(curTableData[i].creditAmount) - Number(curTableData[i].debitAmount)).toFixed(2)
          }
          if (i > 0 && curTableData[i].detailNum === curTableData[i - 1].detailNum) {
            if (
                (curTableData[i].debitAmount > 0 && curTableData[i - 1].debitAmount > 0) ||
                (curTableData[i].creditAmount > 0 && curTableData[i - 1].creditAmount > 0)
            ) {
              if (isEmpty(curTableData[i - 1].class)) {
                toggleColor = toggleColor === "row-bg-1" ? "row-bg-2" : "row-bg-1";
              }
              curTableData[i].class = toggleColor;
              curTableData[i - 1].class = toggleColor;
            }
          }
          if (isEmpty(curTableData[i].class)) {
            toggleColor = toggleColor === "row-bg-1" ? "row-bg-2" : "row-bg-1";
            curTableData[i].class = toggleColor;
          }
          if (isNotEmpty(obj.debitAmountTotal)) {
            obj.creditAmountTotal = 0;
          } else if (isNotEmpty(obj.creditAmountTotal)) {
            obj.debitAmountTotal = 0;
          }
          this.tableData.push(obj);
        }

        this.loading = false;
      } else {
        if (empties.includes(res.message)) res.message = "接口异常";
        this.$XModal.message(res.message);
      }
    },
    pageChange(page) {
      this.page.currentPage = page.currentPage;
      this.page.pageSize = page.pageSize;
      this.getListData();
    },
    footerCellClassName({$rowIndex, column, columnIndex}) {
      return "footer-cell";
    },
    footerMethod({columns, data}) {
      return bankLogFooter({columns, data});
    },
    openOrder(row) {
      this.openOrderDetailTwo(row.orderId);
    },
    viewDetail(row) {
      this.cate = "Payment";
      this.isShowPaymentDetail = true;
      this.$refs.paymentDetail.setEdit(false);
      this.$refs.paymentDetail.init(row.paymentId, this.cate, 1);
    },
    editDetail(row) {
      this.cate = "Payment";
      this.isShowPaymentDetail = true;
      this.$refs.paymentDetail.setEdit(true);
      this.$refs.paymentDetail.init(row.paymentId, this.cate, 1);
    },
    closeClearData() {
      this.isShowClearData = false;
      this.getListData();
    },
    getRowClass(e) {
      return e.row.class;
    },
  },
};
</script>
<style scoped>
.finance-header .ivu-select {
  width: 140px;
  height: 34px;
  overflow: hidden;
}

.finance-header >>> .ivu-select-input {
  overflow: hidden;
}

/* .vxe-table .vxe-body--column, .vxe-table .vxe-footer--column, .vxe-table .vxe-header--column{
    line-height: 48px;
  } */

.vxe-table .row-bg-1 {
  width: calc(100% + 30px);
  height: 48px;
  line-height: 48px;
  vertical-align: middle;
  background-color: rgb(250, 250, 250);
  margin: 0 -15px;
  padding: 0;
}

.modal-footer {
  padding: 10px 0;
  display: flex;
  justify-content: flex-end;
  width: 96%;
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
}
</style>
